import * as React from "react";
const Clear = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "12", r: "12", opacity: ".06" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M18 6.707L17.293 6 12 11.293 6.707 6 6 6.707 11.293 12 6 17.293l.707.707L12 12.707 17.293 18l.707-.707L12.707 12 18 6.707z" }));
Clear.displayName = "Clear";
var Clear_default = Clear;
export {
  Clear_default as default
};
